export const cleanCornerId = (cornerId: string | number) => {
  return `${cornerId}`.replace(/0000000\d$/g, "");
};
